import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';
import { Color } from '~common/model/basics';

export const PlusIcon: React.FunctionComponent<IconProps> = ({
  width = 16,
  height = 16,
  color = Color.White,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={16} viewBoxHeight={16} color={color} {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.51537 9.43212H1.70019C1.14791 9.43212 0.700195 8.9844 0.700195 8.43212V7.44769C0.700195 6.8954 1.14791 6.44769 1.7002 6.44769H6.51537V1.3999C6.51537 0.847616 6.96309 0.399902 7.51537 0.399902H8.42348C8.97576 0.399902 9.42348 0.847617 9.42348 1.3999V6.44769H14.2387C14.7909 6.44769 15.2387 6.8954 15.2387 7.44769V8.43212C15.2387 8.9844 14.7909 9.43212 14.2387 9.43212H9.42348V14.4799C9.42348 15.0322 8.97576 15.4799 8.42348 15.4799H7.51537C6.96309 15.4799 6.51537 15.0322 6.51537 14.4799V9.43212Z"
    />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/icon/plus.icon.tsx